

import { useState, useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { FiX } from "react-icons/fi"
import { MdOutlineTableRestaurant } from "react-icons/md"
import { GiKnifeFork } from "react-icons/gi"

export default function TablePopupSelector({ tables = [], onSelect, holdInvoiceData }) {
  const [showPopup, setShowPopup] = useState(false)
  const [selected, setSelected] = useState(null)
  const [loader, setLoader] = useState(true)
  const [contextMenu, setContextMenu] = useState(null) // {x, y, table, invoice}
  const [viewModalData, setViewModalData] = useState(null) // invoice object for modal
  const location = useLocation()
  const navigate = useNavigate()

  // Open popup if URL is /billing
  useEffect(() => {
    if (location.pathname === "/billing") {
      setShowPopup(true)
    }
  }, [location])

  useEffect(() => {
    if (tables.length > 0) {
      setTimeout(() => {
        setLoader(false)
      }, 500)
    }
  }, [tables])

  // Handle selecting a table
  const handleSelect = (table) => {
    const isBooked = holdInvoiceData.some((invoice) => {
      const tableName = invoice?.table?.label || ""
      const hasTableWord = tableName.toLowerCase().includes("table")
      return hasTableWord && invoice.table_id === table.value
    })
    if (isBooked) return
    setSelected(table)
    onSelect(table)
    setShowPopup(false)
  }

  // Handle right click
  const handleRightClick = (e, table) => {
    console.log("inside Context menue")
    e.preventDefault()
    const invoice = holdInvoiceData.find((inv) => inv.table_id === table.value)
    console.log("inside Context menue.... invoice ", invoice)
    if (!invoice) return

    setContextMenu({
      x: e.clientX,
      y: e.clientY,
      table,
      invoice,
    })
  }
  console.log("hold invoice ", holdInvoiceData)
  console.log("Context menue....", contextMenu)
  // Handle View
  const handleView = () => {
    if (contextMenu?.invoice) {
      setViewModalData(contextMenu.invoice)
    }
    setContextMenu(null)
  }

  // Handle Payment
  const handlePayment = () => {
    if (contextMenu?.invoice) {
      navigate(`/invoice/edit/${contextMenu.invoice.invoice_id}`)
    }
    setContextMenu(null)
  }

  // Close context menu on click elsewhere
  useEffect(() => {
    const closeMenu = () => setContextMenu(null)
    window.addEventListener("click", closeMenu)
    return () => window.removeEventListener("click", closeMenu)
  }, [])

  const bookedTableIds = holdInvoiceData
    .filter((invoice) => {
      const tableName = invoice?.table?.table_name || ""
      return /table/i.test(tableName) // Matches "Table" or "table" (case-insensitive)
    })
    .map((invoice) => invoice.table_id)

  return (
    <div className="mt-0">
      <label className="block text-sm font-semibold mb-1 text-slate-700 tracking-wide">Restaurant Table</label>
      <button
        onClick={() => setShowPopup(true)}
        className="px-3 py-2 bg-white border-2 border-slate-200 rounded-xl w-full text-left font-medium text-slate-700 hover:border-emerald-300 hover:bg-emerald-50 transition-all duration-200 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-opacity-20"
      >

        {selected?.label || "Select Table"}
      </button>

      {showPopup && (
        <div className="fixed inset-0 z-[9999] bg-slate-900 bg-opacity-60 backdrop-blur-sm flex justify-center items-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden shadow-2xl border border-slate-200 animate-in fade-in-0 zoom-in-95 duration-300">
            <div className="flex justify-between items-center px-8 py-6 border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white">
              <div>
                <h2 className="text-2xl font-bold text-slate-800">Select a Table</h2>
                <p className="text-sm text-slate-500 mt-1">Choose an available table for your order</p>
              </div>
              <button
                onClick={() => setShowPopup(false)}
                className="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-white hover:bg-red-500 rounded-full transition-all duration-200 hover:scale-105"
              >
                <FiX size={20} />
              </button>
            </div>

            <div className="p-8 overflow-y-auto max-h-[calc(90vh-120px)]">
              {loader ? (
                <div className="flex justify-center items-center h-64">
                  <div className="relative">
                    <div className="w-16 h-16 border-4 border-emerald-200 border-t-emerald-500 rounded-full animate-spin"></div>
                    <div className="mt-4 text-slate-600 font-medium">Loading tables...</div>
                  </div>
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
                  {tables.map((table) => {
                    const isBooked = bookedTableIds.includes(table.value)
                    const isSelected = selected?.value === table.value

                    return (
                      <button
                        key={table.value}
                        onClick={() => handleSelect(table)}
                        onContextMenu={(e) => handleRightClick(e, table)}
                        disabled={isBooked}
                        className={`group relative w-full h-24 rounded-2xl border-2 transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-opacity-20 ${
                          isBooked
                            ? "bg-white border-2 border-red-500 text-white font-bold animate-pulse"
                            : isSelected
                              ? "bg-gradient-to-br from-emerald-500 to-emerald-600 border-emerald-500 text-white shadow-lg shadow-emerald-500/25"
                              : "bg-white border-slate-200 hover:border-emerald-300 hover:shadow-lg hover:shadow-emerald-500/10 text-slate-700"
                        }`}
                      >
                        <div className="flex flex-col items-center justify-center h-full space-y-2">
                          <MdOutlineTableRestaurant
                            className={`text-3xl transition-colors ${
                              isBooked
                                ? "text-slate-400"
                                : isSelected
                                  ? "text-white"
                                  : "text-emerald-500 group-hover:text-emerald-600"
                            }`}
                          />
                          <span
                            className={`font-semibold text-lg ${
                              isBooked ? "text-slate-500" : isSelected ? "text-white" : "text-slate-700"
                            }`}
                          >
                            {table.label}
                          </span>
                          {isBooked && (
                            <span className="absolute top-1 right-1 bg-red-500 text-white text-xs px-2 py-1 rounded-full font-medium">
                              Booked
                            </span>
                          )}
                        </div>

                        {!isBooked && !isSelected && (
                          <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/0 to-emerald-600/0 group-hover:from-emerald-500/5 group-hover:to-emerald-600/10 rounded-2xl transition-all duration-300"></div>
                        )}
                      </button>
                    )
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Context Menu */}
      {contextMenu && (
        <div
          className="fixed bg-white border border-slate-200 rounded-xl shadow-2xl z-[99999] overflow-hidden animate-in fade-in-0 zoom-in-95 duration-200"
          style={{
            top: contextMenu.y,
            left: contextMenu.x,
          }}
        >
          <button
            onClick={handleView}
            className="block w-full text-left px-5 py-3 hover:bg-emerald-50 text-slate-700 font-medium transition-colors border-b border-slate-100 last:border-b-0"
          >
            View Details
          </button>
          <button
            onClick={handlePayment}
            className="block w-full text-left px-5 py-3 hover:bg-emerald-50 text-slate-700 font-medium transition-colors"
          >
            Process Payment
          </button>
        </div>
      )}

      {/* View Modal */}
      {viewModalData && (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg transform transition-all animate-in fade-in-0 zoom-in-95 duration-300 border border-slate-200">
            {/* Header */}
            <div className="flex justify-between items-center border-b border-slate-200 px-6 py-5 bg-gradient-to-r from-slate-50 to-white rounded-t-2xl">
              <div>
                <h2 className="text-xl font-bold text-slate-800">
                  {tables.find((t) => t.value === viewModalData.table_id)?.label}
                </h2>
                <p className="text-sm text-slate-500 mt-1">Table Details</p>
              </div>
              <button
                onClick={() => setViewModalData(null)}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-slate-100 hover:bg-red-500 hover:text-white text-slate-400 transition-all duration-200 hover:scale-105"
              >
                <FiX size={18} />
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-6 space-y-6">
              <div className="bg-slate-50 rounded-xl p-4">
                <span className="block text-sm font-semibold text-slate-500 uppercase tracking-wide mb-2">Waiter</span>
                <p className="text-lg font-semibold text-slate-800">{viewModalData.saler?.name}</p>
              </div>

              {/* Product List */}
              <div>
                <span className="block text-sm font-semibold text-slate-500 uppercase tracking-wide mb-4">
                  Items Ordered
                </span>
                <div className="space-y-3 max-h-64 overflow-y-auto">
                  {viewModalData.sales_details?.map((item, idx) => (
                    <div
                      key={idx}
                      className="flex items-center gap-4 p-4 rounded-xl bg-gradient-to-r from-emerald-50 to-emerald-50/50 border border-emerald-100 hover:shadow-md transition-all duration-200"
                    >
                      <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center">
                        <GiKnifeFork className="text-white text-lg" />
                      </div>
                      <div className="flex-1">
                        <span className="font-semibold text-slate-800 block">{item.product_info?.name}</span>
                        <span className="text-sm text-slate-500">Quantity: {item.qty}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="flex justify-end border-t border-slate-200 px-6 py-4 bg-slate-50 rounded-b-2xl">
              <button
                onClick={() => setViewModalData(null)}
                className="px-6 py-2.5 rounded-xl bg-emerald-500 text-white font-semibold hover:bg-emerald-600 transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-4 focus:ring-emerald-500 focus:ring-opacity-20"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
